import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import Select from "react-select";

const PenjodohanV2Wrapper = (props) => {

    const [selectedOptions, setSelectedOptions] = useState({});
    const [answerOpts, setAnswerOpts] = useState([]);

    useEffect(() => {
        const flattened = props.answer.flat(1);
        const uniqueFlattened = [...new Set(flattened)];
        const options = uniqueFlattened.map((item) => ({
            value: item,
            label: item,
        }));
        setAnswerOpts(options);
        getAvailableOptions();
    }, [props]);

    const handleSelectChange = (value, questionIndex) => {
        setSelectedOptions(prev => ({
            ...prev,
            [questionIndex]: value
        }));
    };

    const getAvailableOptions = () => {
        const uniqueList = [...new Set(props.answer)];
        return uniqueList.map((item) => ({
            value: item,
            label: item,
        }));
    };

    const simpan = () => {
        console.log(selectedOptions);
        //return from (question label) and to (answer label)
        const result = Object.keys(selectedOptions).map((key) => {
            const question = props.question[key];
            const answer = selectedOptions[key]?.value;
            return { "from": question, "to": answer };
        });

        console.log(result);
        
        props.onChange({"links": result});
    }

    return (
        <div id="jodoh" className="jodoh">
            <Row>
                <Col xs={6} lg={6}>
                    <Card  className="no-padding">
                        <div className="card-header border-0">
                            <h4 className="fs-20 mb-0">Pertanyaan</h4>
                        </div>
                        <Card.Body className="no-padding">
                            {props.question && props.question.map((question, index) => (
                                <div key={index} className="mb-3">
                                    <p className="mb-2">{question}</p>
                                    <Select
                                        value={selectedOptions[index] || null}
                                        onChange={(value) => handleSelectChange(value, index)}
                                        options={answerOpts}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: '20px',
                                                fontSize: '12px'
                                            })
                                        }}
                                    />
                                </div>
                            ))}
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={6} lg={6}>
                    <Card>
                        <div className="card-header border-0 pb-0">
                            <h4 className="fs-20 mb-0">Jawaban</h4>
                        </div>
                        <Card.Body>
                            <ul className="unorder-list mb-3">
                                <ul className="list-group">
                                    {props.answer && answerOpts.map((answer, index) => (
                                        <li key={index} className="list-group-item d-flex align-items-center">
                                            {/* <span className="badge badge-primary me-2">{String.fromCharCode(65 + index)}</span> */}
                                            {answer.label}
                                        </li>
                                    ))}
                                </ul>
                            </ul>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Button className="me-2 mt-2" variant="primary btn-md" onClick={() => simpan()}>Simpan</Button>
        </div>
    );
}

export default PenjodohanV2Wrapper;